import serviceProvider from "../../services/provider/ProviderService";
import serviceDocument from "../../services/patient/DocumentService";
import serviceOrder from "../../services/orders/OrderService.js";
import PatientService from "../../services/patient/PatientService";
import vademecum from "../../services/policy/policy-medicine.js";
import locationService from "../../services/location/LocationService";
import i18n from "../../i18n/index";
import { StorageService } from "../../services/StorageService";
import dayjs from "dayjs";
import serviceForceShippingFee from "../../services/force-shipping-fee/ForceShippingFeeService";
import servicePatient from "../../services/patient/PatientService";
import serviceCalendar from "../../services/calendar/serviceCalendar";
import timeZoneService from '../../services/scheduleRange/ScheduleRange';
import parametersService from '../../services/parameters/ParametersService.js';

export default {
  components: {},
  data: () => ({
    loading: false,
    showGrid: false,
    panel: [],
    dialog: false,
    menuDelivery: false,
    providers: [],
    observation: "",
    observationMed: "",
    date: new Date().toISOString().substr(0, 10),
    menu2: false,
    attachments: [],
    createReminder: false,
    showProvider: false,
    patientListData: [],
    disableSaveButton: false,
    showProviderColumn: false,

    rules: { required: (value) => !!value || "El campo es requerido" },
    states: [],
    cities: [],
    branches: [],
    documentTypeItems: [],
    dataMedicines: [],
    orderPatient: [],
    orderTypeItems: ["EXCLUSIVO", "INTEGRADO"],
    itemTypeOrder: [
      {
        id: "EXCLUSIVE",
        name: "Exclusivo",
      },
      {
        id: "INTEGRATED",
        name: "Integrado",
      },
    ],
    scheduleRanges: [],
    numbreThree: "",
    numberTwo: "",
    numberOne: "",
    nameNomenclature: "",
    nomenclature: [
      "Anillo",
      "Autopista",
      "Avenida",
      "Avenida Calle",
      "Avenida Carrera",
      "Bulevar",
      "Calle",
      "Carretera",
      "Carrera",
      "Circular",
      "Circunvalar",
      "Conjunto",
      "Diagonal",
      "Glorieta",
      "Kilómetro",
      "Loma",
      "Manzana",
      "Parcela",
      "Pasaje",
      "Paseo",
      "Peatonal",
      "Sector",
      "Sendero",
      "Transversal",
      "Troncal",
      "Vereda",
      "Vía",
      "Zona",
    ],

    location: {
      state: "",
      city: "",
      branch: "",
      scheduleRange: "",
    },

    patient: {
      id: "",
      type: "",
      document: "",
      fullname: "",
      address: "",
      cellPhoneNumber: "",
      phoneNumber: "",
      isPac: false,
      isPolicy: false,
    },

    order: {
      status: "",
      number: "",
      deliveryAddress: "",
      orderType: "",
      deliveryDate: "",
      notApplyShippingFee: false,
    },

    headers: [
      {
        sortable: false,
        text: "Nro. Orden",
        value: "orderCode",
        align: "center",
      },
      { sortable: false, text: "PLU", value: "pluCode", align: "center" },
      {
        sortable: false,
        text: "Descripción",
        value: "descriptionActiveIngredient",
        align: "center",
      },
      { sortable: false, text: "Cantidad", value: "count", align: "center" },
      {
        sortable: false,
        text: "Prestador",
        value: "providerName",
        align: "center",
      },
      {
        sortable: false,
        text: "Valor cuota moderadora",
        value: "scaleFee",
        align: "center",
      },
    ],

    orderDetail: [],

    itemMedicine: {
      document: "",
      fullname: "",
      orderCode: "",
      pluCode: "",
      medicine: {
        pluCode: "",
        descriptionActiveIngredient: "",
      },
      count: "",
      providerName: "",
      scaleFee: "",
    },

    dataMedicines: [],
    bin: [],
    vademecumData: [],
    medicine: {},
    scaleFee: [],
    slidingScaleFeeTotal: 0,
    fechaAllowed: "",
    typePropertys: [
      "-Tipo de inmueble-",
      "Casa",
      "Edificio",
      "Hotel",
      "Oficina",
      "Urbanización",
    ],
    typeProperty: "",
    blockOrInteriors: [
      "-Bloque o interior-",
      "Manzana",
      "Zona",
      "Bloque",
      "Habitación",
      "Apartamento",
      "Piso",
    ],
    blockOrInterior: "",
    selectedFiles: [],
    observationOne: "",
    observationTwo: "",
    isPrioritizedPatient: false,
    forceShippingFee: [],
    isPAC: false,
    hasPolicy: false,
    maxDate: "",
    dataMedicines: [],
  }),
  created() {
    // this.activeProvider()
  },

  mounted() {
    this.getDocumentTypes();
    this.getProviders();
    this.getMedicines();
    this.getForceShippingFee();
  },

  methods: {
    getrangebranch() {
      timeZoneService.getScheduleRanges().then((response) => {
        this.scheduleRanges = response.data;
        // this.scheduleRanges.forEach(sr => sr.range = sr.start + ' - ' + sr.end);
        this.scheduleRanges.forEach(
          (sr) =>
            (sr.range = `${sr.idScheduleRange.start} - ${sr.idScheduleRange.end}`)
        );
      });
      this.disableBranches = true;
    },
    removeFile(index) {
      this.selectedFiles.splice(index, 1);
    },
    handleFileRemove(file) {
      // Este método se llama cuando se elimina un archivo desde b-upload
      console.log("Archivo eliminado:", file);
    },
    async cleanDocument() {
      this.patient.document = "";
    },
    async getPatientDetails() {
      const documentType = this.documentTypeItems.find(
        (doc) => doc.id === this.patient.type
      );
      let response2 = await servicePatient.prioritizedPatient(
        this.patient.document,
        documentType.code
      );
      let patient = response2.data;
      if (!patient.code) {
        this.isPrioritizedPatient = true;
        this.isPAC = patient.isPAC;
        this.hasPolicy = patient.hasPolicy;
      }
    },
    async getForceShippingFee() {
      try {
        let response = await serviceForceShippingFee.forceShippingFeeAll();
        if (response.data.code === "No data available") {
          this.forceShippingFee = [];
        } else {
          this.forceShippingFee = response.data.map((data) => data.idCity);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async updateOrderType() {
      let providersAux = [];
      this.dataMedicines.forEach((medicine) => {
        if (medicine.check === true) {
          if (!providersAux.includes(medicine.providerName)) {
            providersAux.push(medicine.providerName);
          }
        }
      });
      const moreThanOneProvider = providersAux.length > 1;
      this.itemTypeOrder = [
        { id: "EXCLUSIVE", name: "Póliza" },
        { id: "INTEGRATED", name: "Integrado" },
      ];
      const oldOrderType = this.order.orderType;
      this.order.orderType = !moreThanOneProvider
        ? this.itemTypeOrder[0].id
        : this.itemTypeOrder[1].id;

      if (oldOrderType !== this.order.orderType) {
        await this.getStates();
        this.getCities();
        this.getBranches();
      }

      order.orderType.name = "PÓLIZA";
    },
    async loadbranch(idState, idCity) {
      await this.getStates();
      this.location.state = idState;
      await this.getCities(idCity);
      this.location.city = idCity;
      this.order.orderType = "EXCLUSIVE";
      await this.getBranches();
      this.itemTypeOrder = [
        { id: "EXCLUSIVE", name: "Póliza" },
        { id: "INTEGRATED", name: "Integrado" },
      ];
      this.order.orderType = "EXCLUSIVE";

      //order.orderType.name = "PÓLIZA";
    },
    getDefaultProviderId() {
      let providerId = -1;
      if (
        this.order.orderType === this.itemTypeOrder[0].id &&
        this.dataMedicines.length > 0
      ) {
        providerId = this.dataMedicines[0].providerId;
      } else {
        //providerId = StorageService.getIntegratedProvider();
        providerId = 2;
      }
      return providerId;
    },
    activeProvider() {
      let user = JSON.parse(localStorage.getItem("user"));
      let providerId = user.providerId;

      if (providerId === 1) {
        this.showProvider = true;
      }

      if (providerId !== 1) {
        this.showProviderColumn = false;
        this.headers.splice(6, 1);
      }
    },

    getMedicines() {
      let medicines = [];
      for (let index = 0; index < this.dataMedicines.length; index++) {
        const medicine = this.dataMedicines[index];
        medicines.push({
          fullname: medicine.fullname,
          document: medicine.document,
          id: undefined,
          pluCode: medicine.pluCode,
          descriptionActiveIngredient: medicine.descriptionActiveIngredient,
          count: medicine.count,
          nextShippingDate: undefined,
          orderCode: medicine.orderCode,
          providerName: medicine.providerName,
          scaleFee: medicine.scaleFee,
          deliveryNumber: "1/1",
          status: "NO_STATUS",
          isApplicable: false,
          isWatched: false,
          isFeatured: false,
        });
      }
      return medicines;
    },

    async saveScheduling(typeUser) {
      this.disableSaveButton = true;
      if (this.patientListData.length === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-no-patients"),
        });
        this.disableSaveButton = false;
        return;
      }

      if (JSON.stringify(this.patient) === "{}") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.error-no-patients"),
        });
        this.disableSaveButton = false;
        return;
      }

      if (this.location.state === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-state"),
        });
        this.disableSaveButton = false;
        return;
      }

      if (this.location.city === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-city"),
        });
        this.disableSaveButton = false;
        return;
      }

      if (this.location.scheduleRange === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-schedule-range"),
        });
        this.disableSaveButton = false;
        return;
      }

      if (this.order.deliveryDate === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-delivery-date"),
        });
        this.disableSaveButton = false;
        return;
      }

      if (
        this.nameNomenclature === "" ||
        this.numberOne === "" ||
        this.numberTwo === "" ||
        this.numbreThree === "" ||
        this.nameNomenclature === null ||
        this.numberOne === null ||
        this.numberTwo === null ||
        this.numbreThree === null ||
        this.nameNomenclature === undefined ||
        this.numberOne === undefined ||
        this.numberTwo === undefined ||
        this.numbreThree === undefined
      ) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Falta un campo en la dirección",
        });
        this.disableSaveButton = false;
        return;
      }

      if (this.dataMedicines.length === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: "El pedido debe tener al menos una autorización asociada.",
        });
        this.disableSaveButton = false;
        return;
      }

      this.order.status = "SCHEDULED";

      let medicines = [];
      for (let index2 = 0; index2 < this.scaleFee.length; index2++) {
        let orderAux = this.scaleFee[index2];
        medicines[orderAux.orderCode] = [];
        for (let index = 0; index < this.dataMedicines.length; index++) {
          const medicine = this.dataMedicines[index];
          if (medicine.orderCode === orderAux.orderCode) {
            medicines[orderAux.orderCode].push({
              fullname: medicine.fullname,
              document: medicine.document,
              plu: medicine.pluCode,
              description: medicine.descriptionActiveIngredient,
              count: medicine.count,
              orderCode: medicine.orderCode,
              providerName: medicine.providerName,
              scaleFee: medicine.scaleFee,
              deliveryNumber: "1/1",
              status: "NO_STATUS",
              isApplicable: false,
              isWatched: false,
              isFeatured: false,
            });
          }
        }
      }

      let auxOrderDetail = [];

      for (let index2 = 0; index2 < this.scaleFee.length; index2++) {
        let orderAux = this.scaleFee[index2];
        let auxProvider = this.providers.find((provider) => {
          return (
            provider.name === medicines[orderAux.orderCode][0].providerName
          );
        });
        auxOrderDetail.push({
          orderCode: orderAux.orderCode,
          providerId: auxProvider.id,
          providerName: auxProvider.name,
          scaleFee: medicines[orderAux.orderCode][0].scaleFee,
          deliveryNumber: "1/1",
          status: "NO_STATUS",
          paymentType: "NN",
          medicines: medicines[orderAux.orderCode],
        });
      }

      if (this.typeProperty === "-Tipo de inmueble-") {
        this.typeProperty = "";
      }
      if (this.blockOrInterior === "-Bloque o interior-") {
        this.blockOrInterior = "";
      }
      this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`;
      this.order.nameNomenclature = this.nameNomenclature;
      this.order.numberOne = this.numberOne;
      this.order.numberTwo = this.numberTwo;
      this.order.numbreThree = this.numbreThree;

      this.order.typeProperty = this.typeProperty;
      this.order.observationOne = this.observationOne;
      this.order.blockOrInterior = this.blockOrInterior;
      this.order.observationTwo = this.observationTwo;

      if (
        this.isPrioritizedPatient &&
        !this.contains(this.forceShippingFee, this.location.city)
      ) {
        this.order.notApplyShippingFee = true;
      }

      if (this.contains(this.forceShippingFee, this.location.city)) {
        this.order.notApplyShippingFee = false;
      }

      let formData = {
        patients: this.patientListData,
        orderData: {
          ...this.order,
          orderDetail: auxOrderDetail,
          location: this.location,
          medicinesList: this.dataMedicines,
          typeUserOrder: typeUser == "manually" ? 8 : null,
        },

        note: this.notes,
        observation: this.observation,
        observationMed: this.observationMed,
        // createReminder: this.createReminder,
        userId: StorageService.getUserData().id,
        orderManually: true,
      };
      try {
        const responseScheduling = await serviceOrder.createOrder_policy(
          formData
        );
        if (this.attachments.length > 0) {
          if (this.attachments[0].size) {
            let responseUpload = await serviceOrder.uploadAttachment(
              responseScheduling.data.id,
              this.attachments
            );
          }
        }
        this.$notify({
          group: "app",
          type: "success",
          text: "Pedido guardado con éxito.",
        });
        this.closeOrder();
      } catch (error) {
        this.disableSaveButton = false;
        this.$notify({
          group: "app",
          type: "error",
          text: "Ha ocurrido un error al agendar el pedido",
        });
      }
    },

    async getDate() {
      const formDate = this.formatDate(new Date());
      const providerId = this.getDefaultProviderId();
      let data = {
        idProvider: providerId,
        date: formDate,
        orderType: this.order.orderType,
        spoiled: true,
      };
      let auxResul = [];
      const parameter_rol = (await parametersService.getParameterById(18)).data
        .value;
      const parameter_hour = (await parametersService.getParameterById(19)).data
        .value;
      let user = JSON.parse(localStorage.getItem("user"));
      let nowdayallowed = false;
      const horaActual = parseInt(dayjs().format("HH"));
      await serviceCalendar
        .getAllowedDates(this.location.branch, false, true)
        .then((result) => {
          if (result.data.length == 0) {
            return this.$notify({
              group: "app",
              type: "error",
              text: "No hay configuración de calendario para la sede seleccionada",
            });
          } else {
            //const auxResul = [];
            // ----- regla segun perfil ----------

            if (
              parseInt(user.rol) === parseInt(parameter_rol) &&
              parseInt(horaActual) <= parseInt(parameter_hour)
            ) {
              auxResul.push(dayjs().format("YYYY-MM-DD"));
              nowdayallowed = true;
            }

            //----------------------------------------
            result.data.map((item) => {
              auxResul.push(dayjs(item).format("YYYY-MM-DD"));
            });

            this.daysOfWeek = auxResul;
            this.maxDate = dayjs(
              result.data.length > 5
                ? result.data[5]
                : result.data[result.data.length - 1]
            ).format("YYYY-MM-DD");

            this.fechaAllowed = nowdayallowed
              ? dayjs().format("YYYY-MM-DD")
              : dayjs(result.data[0]).format("YYYY-MM-DD");
            if (!this.order.id) {
              this.order.deliveryDate = this.fechaAllowed;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.allowedDates();
    },
    formatDate(date) {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let zeroInDay = day.toString().length > 1 ? day : `0${day}`;
      let zeroInMonth = month.toString().length > 1 ? month : `0${month}`;
      return `${year}-${zeroInMonth}-${zeroInDay}`;
    },
    allowedDates(val) {
      for (var i = 0; i < this.daysOfWeek.length; i++) {
        if (this.daysOfWeek[i] == val) {
          return val;
        }
      }
    },
    closeOrder() {
      this.validPrestador = "";
      location.reload();
      // this.$refs.validFormPatient.reset()
      // if (this.$refs.attachButton) this.$refs.attachButton.clear()
      // if (this.$refs.validFormOrder) this.$refs.validFormOrder.reset()
      // if (this.$refs.validFormData) this.$refs.validFormData.reset()
      // this.slidingScaleFeeTotal = 0
      // this.patientListData = []
      // this.patient = {
      //   id: '',
      //   type: '',
      //   document: '',
      //   fullname: '',
      //   address: '',
      //   cellPhoneNumber: '',
      //   phoneNumber: '',
      //   isPac: false,
      //   isPolicy: false
      // }
      // this.dataMedicines = []
      // this.panel = []
      // this.dialog = false
      // this.showGrid = false
      // this.attachment = { name: '' }
    },

    contains(arr, id) {
      return arr.some((e) => e.id === id);
    },

    showNoCoverageForAnyCity(type) {
      this.$notify({
        group: "app",
        type,
        text: i18n.t("app.scheduling.no-coverage-area"),
      });
    },

    filterKeyCount(e) {
      const key = e.key;
      if (/[0-9]/.test(key)) {
      } else {
        return e.preventDefault();
      }
    },

    filterKeyCountDocument(e) {
      const key = e.key;
      if (
        this.patient.type == 1 ||
        this.patient.type == 7 ||
        this.patient.type == 16 ||
        this.patient.type == 8
      ) {
        if (/[0-9]/.test(key)) {
        } else {
          return e.preventDefault();
        }
      }
    },

    filterKey(e) {
      const key = e.key;
      if (/[0-9--]/.test(key)) {
      } else {
        return e.preventDefault();
      }
    },
    filterKeyletters(e) {
      const key = e.key;
      if (/[A-Za-z- ]/.test(key)) {
      } else {
        return e.preventDefault();
      }
    },

    showError(text) {
      this.$notify({
        group: "app",
        type: "error",
        text,
      });
    },

    // eslint-disable-next-line no-dupe-keys
    getMedicines() {
      vademecum.getVademecumOrder().then((response) => {
        this.vademecumData = response.data;
        for (let index = 0; index < this.vademecumData.length; index++) {
          const medicine = this.vademecumData[index];
          if (medicine.isApplicable || medicine.isWatched) {
            this.vademecumData[index].disabled = true;
          }
        }
        return this.vademecumData;
      });
    },

    customFilter(item, queryText, itemText) {
      const textOne = item.descriptionActiveIngredient.toLowerCase();
      const textTwo = item.pluCode.toLowerCase();
      const textTree = item.ActiveIngredient.toLowerCase();
      const textFour = item.nameTrade.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textTree.indexOf(searchText) > -1 ||
        textFour.indexOf(searchText) > -1
      );
    },

    getDocumentTypes() {
      serviceDocument.getDocuments().then((response) => {
        this.documentTypeItems = response.data;
      });
    },

    async searchPatient() {
      this.loading = true;
      if (!this.patient.type) {
        this.showError(i18n.t("no-options-selected-for-document-type"));
        return;
      }

      if (!this.patient.document) {
        this.showError(i18n.t("no-patient-id"));
        return;
      }

      await PatientService.getByDocument(
        this.patient.type,
        this.patient.document
      ).then((response) => {
        if (response && response.data && response.data.id) {
          const data = response.data;
          this.patient.id = data.id;
          this.patient.fullname = data.name;
          this.patient.address = data.address;
          this.patient.cellPhoneNumber = data.mobilePhone;
          this.patient.phoneNumber = data.phone;
          this.patient.isPac = data.PAC;
          this.patient.isPolicy = data.policy;

          this.order.deliveryAddress = "";
          this.nameNomenclature = "";
          this.numberOne = "";
          this.numberTwo = "";
          this.numbreThree = "";

          this.typeProperty = "";
          this.observationOne = "";
          this.blockOrInterior = "";
          this.observationTwo = "";

          this.nameNomenclature = data.nameNomenclature;
          this.numberOne = data.numberOne;
          this.numberTwo = data.numberTwo;
          this.numbreThree = data.numbreThree;

          this.typeProperty = data.typeProperty;
          this.observationOne = data.observationOne;
          this.blockOrInterior = data.blockOrInterior;
          this.observationTwo = data.observationTwo;
          this.order.deliveryAddress = `${this.nameNomenclature}  ${this.numberOne} # ${this.numberTwo} - ${this.numbreThree}`;
          this.loadbranch(data.idState, data.idcity);
          this.loading = false;
        } else {
          this.loading = false;
          this.showError(i18n.t("patient-not-exist"));
        }
      });
    },

    openFileChooser() {
      this.$refs.file.click();
    },

    handleFile() {
      for (let i = 0; i < this.$refs.file.files.length; i++) {
        const file = this.$refs.file.files[i];
        if (file.size && file.size > 20 * 1024 * 1024) {
          // > 2MB
          this.$notify({
            group: "app",
            type: "error",
            text: i18n.t("app.scheduling.error-file-size"),
          });
          this.attachments = [];
          return;
        }
        if (
          file.type != "application/pdf" &&
          file.type != "image/jpeg" &&
          file.type != "image/png"
        ) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Tipo de archivo no permitido",
          });
          this.attachments = [];
          return;
        }
        this.attachments.push(file);
      }
      this.showDownloadAttachment = false;
    },

    deleteTableRow(item) {
      const index = this.dataMedicines.indexOf(item);
      this.dataMedicines.splice(index, 1);
      const orderInarray = this.dataMedicines.find((medicine) => {
        return medicine.orderCode === item.orderCode;
      });
      if (orderInarray === undefined) {
        const index = this.scaleFee.findIndex(
          (element) => element.orderCode === item.orderCode
        );
        if (index >= 0) {
          this.scaleFee.splice(index, 1);
        }
        this.slidingScaleFeeTotal = 0;
        for (const fee of this.scaleFee) {
          this.slidingScaleFeeTotal += parseInt(fee.scaleFee);
        }
      }

      const patientInarray = this.dataMedicines.find((medicine) => {
        return medicine.document === item.document;
      });
      if (patientInarray === undefined) {
        const index = this.patientListData.findIndex(
          (patient) => patient.document === item.document
        );
        if (index >= 0) {
          this.patientListData.splice(index, 1);
        }
      }
      this.updateOrderType();
    },

    addItem() {
      if (this.patient.document === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-document"),
        });
        return;
      }

      if (this.patient.phoneNumber) {
        if (this.patient.phoneNumber.length < 7) {
          this.$notify({
            group: "app",
            type: "error",
            text: "El número de teléfono no puede tener menos de 7 números",
          });
          return;
        }
        if (this.patient.phoneNumber.length > 10) {
          this.$notify({
            group: "app",
            type: "error",
            text: "El número de teléfono debe tener como máximo 10 caracteres.",
          });
          return;
        }
      }

      if (this.patient.cellPhoneNumber === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-cellphone"),
        });
        return;
      }

      if (
        this.patient.cellPhoneNumber === "" ||
        this.patient.cellPhoneNumber === undefined ||
        this.patient.cellPhoneNumber === null
      ) {
        this.$notify({
          group: "app",
          type: "error",
          text: "El campo celular no puede estar vacio.",
        });
        return;
      } else {
        if (this.patient.cellPhoneNumber[0] !== "3") {
          this.$notify({
            group: "app",
            type: "error",
            text: "El número celular debe empezar con el número 3.",
          });
          return;
        }
        if (this.patient.cellPhoneNumber.length < 10) {
          this.$notify({
            group: "app",
            type: "error",
            text: "El número celular debe tener 10 caracteres.",
          });
          return;
        }
        if (this.patient.cellPhoneNumber.length !== 10) {
          this.$notify({
            group: "app",
            type: "error",
            text: "El número celular debe tener 10 caracteres.",
          });
          return;
        }
      }

      if (this.patient.type === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-document-type"),
        });
        return;
      }

      if (this.patient.fullname === "") {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.scheduling.no-name"),
        });
        return;
      } else {
        const auxArr = this.patient.fullname.split(" ");
        if (auxArr.length <= 1) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Debe ingresar el nombre completo",
          });
          return;
        }
      }

      // if (!/(\d+-\d+)/.test(this.itemMedicine.orderCode)) {
      //   this.$notify({
      //     group: 'app',
      //     type: 'error',
      //     text: 'Formato de autorización no válido'
      //   })
      //   return
      // }

      const auxPatient = {
        id: this.patient.id,
        document: this.patient.document,
        documentType: this.patient.type,
        fullname: this.patient.fullname,
        address: this.patient.address,
        mobilePhone: this.patient.cellPhoneNumber,
        phone: this.patient.phoneNumber,
        isPac: false,
        isPolicy: false,
      };
      const document = this.patientListData.find((patient) => {
        return (
          patient.document === auxPatient.document &&
          patient.fullname == auxPatient.fullname
        );
      });
      if (document === undefined && this.patientListData.length === 1) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Solo se permite un paciente",
        });
        return;
      } else if (this.patientListData.length === 0) {
        this.patientListData.push(auxPatient);
      }

      const auxFee = {
        orderCode: this.itemMedicine.orderCode,
        scaleFee: this.itemMedicine.scaleFee,
      };

      const inArray = this.scaleFee.find((fee) => {
        return fee.orderCode === auxFee.orderCode;
      });

      if (inArray === undefined) {
        this.scaleFee.push(auxFee);
      } else {
        if (inArray.scaleFee !== auxFee.scaleFee) {
          this.$notify({
            group: "app",
            type: "error",
            text: "Ya ha ingresado otro valor de cuota moderadora para esta autorización",
          });
          return;
        }
      }

      this.slidingScaleFeeTotal = 0;
      for (const fee of this.scaleFee) {
        this.slidingScaleFeeTotal += parseInt(fee.scaleFee);
      }

      let selectedProvider = this.providers.find(
        (p) => p.name === this.itemMedicine.providerName
      );

      const dataMedicine = this.dataMedicines.find((order) => {
        return (
          order.orderCode === this.itemMedicine.orderCode &&
          order.pluCode === this.medicine.pluCode
        );
      });
      if (!dataMedicine) {
        this.dataMedicines.push({
          check: true,
          fullname: this.patient.fullname,
          document: this.patient.document,
          pluCode: this.medicine.pluCode,
          descriptionActiveIngredient:
            this.medicine.descriptionActiveIngredient,
          count: this.itemMedicine.count,
          orderCode: this.itemMedicine.orderCode,
          providerName: this.itemMedicine.providerName,
          providerId: selectedProvider.id,
          scaleFee: this.itemMedicine.scaleFee,
          deliveryNumber: "1/1",
          status: "NO_STATUS",
          paymentType: "NN",
          isApplicable: false,
          isWatched: false,
          isFeatured: false,
        });
      } else {
        dataMedicine.count =
          Number(dataMedicine.count) + Number(this.itemMedicine.count);
      }

      this.updateOrderType();

      this.itemMedicine.count = "";
      this.medicine = "";
    },

    async getStates(order) {
      let providersAux = [];
      this.dataMedicines.forEach((medicine) => {
        if (medicine.check === true) {
          if (!providersAux.includes(medicine.providerName)) {
            providersAux.push(medicine.providerName);
          }
        }
      });
      const moreThanOneProvider = providersAux.length > 1;

      let type = !moreThanOneProvider
        ? this.itemTypeOrder[0].id
        : this.itemTypeOrder[1].id;

      if (!type) type = "EXCLUSIVE";
      const providerId = this.getDefaultProviderId();

      let response = await locationService.getStatesByProvider(
        1,
        "POLICY",
        providerId
      );
      this.states = response.data;
      if (!this.contains(this.states, this.location.state)) {
        this.location.state = "";
      }
      if (!this.contains(this.cities, this.location.city)) {
        this.location.city = "";
      }
      if (!this.contains(this.branches, this.location.branch)) {
        this.location.branch = "";
      }
      if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
        this.location.scheduleRange = "";
      }
      if (this.states.length === 0) {
        this.showNoCoverageForAnyCity("warning");
      }
    },
    async getCities(order) {
      if (!this.location.state) return;

      let providersAux = [];
      this.dataMedicines.forEach((medicine) => {
        if (medicine.check === true) {
          if (!providersAux.includes(medicine.providerName)) {
            providersAux.push(medicine.providerName);
          }
        }
      });
      const moreThanOneProvider = providersAux.length > 1;

      let type = !moreThanOneProvider
        ? this.itemTypeOrder[0].id
        : this.itemTypeOrder[1].id;

      if (!type) type = "EXCLUSIVE";

      const providerId = this.getDefaultProviderId();

      let response = await locationService.getCitiesByProvider(
        this.location.state,
        "POLICY",
        providerId
      );
      this.cities = response.data;
      this.cities = this.cities.map((c) => c.idCity);
      if (!this.contains(this.cities, this.location.city)) {
        this.location.city = "";
      }
      if (!this.contains(this.branches, this.location.branch)) {
        this.location.branch = "";
      }
      if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
        this.location.scheduleRange = "";
      }
      if (this.cities.length === 0) {
        this.showNoCoverageForAnyCity("warning");
      }
      if (order) {
        this.location.city = order;
        this.lastCitySelected = order;
      }
    },
    async getBranches(order) {
      try {
        if (!this.location.city) return;
        this.disableBranches = true;
        if (this.lastCitySelected != this.location.city) {
          this.lastCitySelected = this.location.city;
          this.location.scheduleRange = "";
          this.location.branch = 0;
          this.scheduleRanges = [];
        }

        const providerId = this.getDefaultProviderId();

        let response =
          await locationService.getBranchesByCityProviderAndTypePolicy(
            this.location.city,
            providerId,
            this.order.orderType,
            this.location.branch
          );
        this.branches = response.data;
        let dta = [];
        if (this.branches && this.branches.length > 0) {
          for (let b of this.branches) {
            for (let bc of b.branchCities) {
              if (
                parseInt(bc.idCity.id) === parseInt(this.location.city) &&
                bc.active === true
              ) {
                dta.push(b);
                break;
              }
            }
          }
          this.location.branch = dta[0].id;
          this.location.scheduleRange = "";
          await this.getScheduleRanges();
        } else {
          this.showNoCoverageForAnyCity("warning");
        }
        this.getDate();
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Ha habido un problema consultando los municipios",
        });
      }
    },
    async getScheduleRanges(order) {
      try {
        if (!this.location.branch) return;

        // let response = await locationService.getScheduleRangesByBranch(
        //     this.location.branch
        // );

        let response = await locationService.getScheduleRangesByBranchPolicy(
          this.location.branch
        );
        if (response.data.code === "No data available") {
          this.scheduleRanges = [];
        } else {
          this.scheduleRanges = response.data.filter((sr) => {
            if (sr.idBranchCity !== null) {
              return sr.idBranchCity.idCity.id === this.location.city;
            }
          });
        }
        await this.getPatientDetails();
        if (
          this.isPrioritizedPatient &&
          !this.isPAC &&
          !this.hasPolicy &&
          !this.contains(this.forceShippingFee, this.location.city)
        ) {
          this.scheduleRanges.forEach((sr) => (sr.shippingFee = 0));
        }
        this.scheduleRanges.forEach(
          (sr) =>
            (sr.range = `${sr.idScheduleRange.start} - ${sr.idScheduleRange.end}`)
        );
        if (!this.contains(this.scheduleRanges, this.location.scheduleRange)) {
          this.location.scheduleRange = "";
        }
        this.disableBranches = false;
        // this.getrangebranch();
        this.$forceUpdate();
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: "Ha habido un problema consultando las franjas horarias",
        });
      }
    },
    getProviders() {
      // serviceProvider.getProviders().then((response) => {
      //     const integratedProvider = StorageService.getIntegratedProvider();
      //     this.providers = response.data.filter(
      //         (item) =>
      //         item.id !== integratedProvider &&
      //         item.name !== "FARMACIA UNIFICADA" &&
      //         item.name !== "" &&
      //         item.name !== "DEMPOS FARMACIA" &&
      //         item.name !== "FARMACIAS NOVA"
      //     );
      // });
      this.providers = [
        {
          name: "PÓLIZA",
          id: 2,
          active: true,
          fiscalNumber: "900277244",
          copayment: null,
        },
      ];
      this.itemMedicine.providerName = this.providers[1];
    },
    onlyNumberAndLetters(e) {
      if (e.key.match(/[a-z0-9ñçáéíóú\s]/i) === null) {
        e.preventDefault();
      }
    },
  },
  computed: {
    isDisabled() {
      return (
        !this.itemMedicine.orderCode ||
        !this.itemMedicine.count ||
        !this.medicine ||
        !this.itemMedicine.scaleFee ||
        !this.itemMedicine.providerName
      );
    },

    notes: {
      get() {
        let ordersForFee = this.dataMedicines
          .filter((m) => m.check)
          .map((item) => {
            return { code: item.orderCode, fee: item.scaleFee };
          });

        ordersForFee = Array.from(new Set(ordersForFee.map((a) => a.code))).map(
          (code) => {
            return ordersForFee.find((a) => a.code === code);
          }
        );

        let slidingScaleFeeTotal = ordersForFee
          .map((item) => item.fee)
          .reduce((a, b) => a + +b, 0);

        let scheduleRange = {};

        if (this.location && this.location.scheduleRange) {
          scheduleRange = this.scheduleRanges.find(
            (scheduleRange) => scheduleRange.id === this.location.scheduleRange
          );
        }

        let shippingFee =
          scheduleRange && scheduleRange.shippingFee
            ? scheduleRange.shippingFee
            : 0;

        if (this.order.notApplyShippingFee) {
          shippingFee = 0;
        }
        let recoveryFeeText = "";
        let ordersForRecoveryFee = this.dataMedicines.filter(
          (m) => m.check && m.paymentType === "CUOTA DE RECUPERACION"
        );

        ordersForRecoveryFee = Array.from(
          new Set(ordersForRecoveryFee.map((a) => a.orderCode))
        );

        if (ordersForRecoveryFee.length > 0) {
          recoveryFeeText =
            "Además, debido a cuota de recuperación, se le cobrará el 10% del valor de los medicamentos de la orden:\n";
          ordersForRecoveryFee.map(
            (item) => (recoveryFeeText += `- ${item}\n`)
          );
        }

        let medicineText =
          this.dataMedicines && this.dataMedicines.length > 0
            ? this.dataMedicines.map((medicine) => {
                if (medicine.check === true) {
                  return `- ${medicine.count} de ${medicine.descriptionActiveIngredient}\n`;
                } else {
                  return "";
                }
              })
            : [];
        medicineText = medicineText.join("");
        return (
          `Su domicilio queda programado para el día ${
            this.order.deliveryDate ? this.order.deliveryDate : " "
          } ` +
          `en el horario ${
            scheduleRange && scheduleRange.range ? scheduleRange.range : " "
          }, ` +
          `los medicamentos que entregaremos serán:\n\n ${medicineText}\n` +
          `El valor de la cuota moderadora será máximo ${
            slidingScaleFeeTotal ? slidingScaleFeeTotal : "0"
          }. ` +
          `${recoveryFeeText}` +
          "Podría ser un valor inferior de acuerdo al precio del medicamento. " +
          `El valor del envío es ${shippingFee}. ` +
          `Para un total de ${slidingScaleFeeTotal + shippingFee}. ` +
          "Como el domicilio queda programado, los medicamentos ya no podrán ser entregados en la farmacia. " +
          "Recuerde esperar al mensajero con documento original o copia del mismo y el valor en efectivo para el pago. " +
          "¡Que tenga un feliz día!"
        );
      },
      set(notes) {
        this.notes = notes;
      },
    },
  },
};